/**
 * Keys for text-backed admin filter values updated through {@code handleTextFilterChange} / {@code onTextFilterChange}.
 */
export enum TextFilterNames {
    SEARCH = 'search',
    CHANGE_LOG_BEFORE = 'changeLogBefore'
}
